import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 320px;
  background: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 32px;
`;

export const HorizontalRuler = styled.hr`
  width: calc(100% - 32px);
  height: 1px;
  border-width: 0;
  color: #cfd8dc;
  background-color: #cfd8dc;
  margin-top: 7px;
  margin-bottom: 7px;
`;
